

  var loaded = false;
  var windowHeight = 0;
  var ticking = false;
  var els = [];
  //el = document.querySelectorAll('.section.section--parallax'),
  //bgEl = document.querySelector('.section.section--parallax .section__bg');

  function updateWindowInformation() {
    windowHeight = window.innerHeight;
  }


  function updatePositions() {
    els.forEach(function(el) {
      updateElement(el.el, el.bg);
    });
    ticking = false;
  }

  function updateElement(el, bg) {
    var rect = el.getBoundingClientRect();
    var bgHeight = bg.scrollHeight;

    // only translate if visible;
    if (bgHeight > 0 && rect.top < windowHeight && rect.bottom > 0) {
      var visibleHeight = rect.bottom - rect.top;
      var diff = (bgHeight - visibleHeight);
      var position = Math.max(Math.min(rect.bottom / (windowHeight + visibleHeight), 1), 0);
      bg.style.transform = 'translateY(' + (diff * position * -1).toFixed(2) + 'px)';
    }
  }

  // This will limit the calculation of the background position to
  // 60fps as well as blocking it from running multiple times at once
  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updatePositions);
      ticking = true;
    }
  }

  // Initialize on domready
  function bootstrap() {
    if (loaded) return;
    loaded = true;

    var parallaxEls = document.querySelectorAll('.section.section--parallax');
    Array.prototype.forEach.call(parallaxEls, function(el) {
      var bg = el.querySelector('.section__bg');
      if (!bg) return;
      els.push({
        el: el,
        bg: bg
      });
    });

    updateWindowInformation();
    updatePositions();
    window.addEventListener('scroll', requestTick, {passive:true});
  }

  if (document.readyState === 'complete') {
    window.requestAnimationFrame(bootstrap);
  } else {
    document.addEventListener('DOMContentLoaded', bootstrap, false);
    window.addEventListener('load', bootstrap, false);
  }

  window.addEventListener('resize', updateWindowInformation);

